module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/plan4-3-b0d3616258076ea86b9b9c1f3bf411bf.webp";